import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchTarget = params => api.request(1, '/targetings', MethodType.GET, params)

export const addTarget = params => api.request(1, '/targetings', MethodType.POST, params, {}, false, {}, [500])
